import { Controller } from '@hotwired/stimulus';

// Stimulus controller for the chat message textarea.
// - auto-resize input to fit its content
// - form submits on enter, while Shift+Enter can be used for newlines

export default class extends Controller {
  static targets = ['input'];

  autosize() {
    const ta = this.inputTarget;
    ta.style.height = 'auto';
    ta.style.height = Math.min(ta.scrollHeight, 168) + 'px';
  }

  handleKeydown(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.inputTarget.closest('form').requestSubmit();
    }
  }
}
